import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';

const ExpandedContext = createContext();

export const ExpandedProvider = ({ children }) => {
  const listRef = useRef(null);
  const [newsData, setNewsData] = useState(['buffer']);
  const [expandedItems, setExpandedItems] = useState({});

  useEffect(() => {
    const initialExpandedItems = {};
    newsData.forEach((news, i) => {
      if (i === 0) return;
      initialExpandedItems[news._id] = expandedItems[news._id] || false;
    });
    setExpandedItems(initialExpandedItems);
  }, [newsData]);

  console.log(expandedItems, 'render');
  const toggleExpanded = useCallback(
    (id) => {
      setExpandedItems((prev) => {
        const newExpandedItems = {
          ...prev,
          [id]: !prev[id],
        };

        if (listRef.current && newsData.length>1) {
          const index = newsData.findIndex((news) => news._id === id);
          console.log(index);
          // const index = Object.keys(newExpandedItems).findIndex((key) => key === id);
          console.log('index', id, index, listRef.current);
          if (!newExpandedItems[id]) {
            listRef.current.scrollToItem(index, 'start');
          }
          listRef.current.resetAfterIndex(index);
        }

        return newExpandedItems;
      });
    },
    [newsData]
  );

  return (
    <ExpandedContext.Provider value={{ expandedItems, toggleExpanded, listRef, newsData, setNewsData }}>
      {children}
    </ExpandedContext.Provider>
  );
};

export const useExpanded = () => useContext(ExpandedContext);
